import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const MobileDevice = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 18 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M8.58333 18.3333H8.59417M3.16667 1H14C15.1966 1 16.1667 1.97005 16.1667 3.16667V20.5C16.1667 21.6966 15.1966 22.6667 14 22.6667H3.16667C1.97005 22.6667 1 21.6966 1 20.5V3.16667C1 1.97005 1.97005 1 3.16667 1Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MobileDevice;
